import type { HomePageData } from "../../services/HomeService";
import { Card, CardContent } from "../ui/card";
import { cn } from "../../lib/utils";
import {
  gluceraMicroLabel,
  gluceraStatNano,
  gluceraSummaryValue,
  gluceraUnitNano,
} from "../../utils/gluceraTypography";

interface PastDateDaySummaryCardProps {
  nutrition?: HomePageData["Today's Nutrition"];
}

const PastDateDaySummaryCard = ({ nutrition }: PastDateDaySummaryCardProps) => (
  <Card className="rounded-2xl border border-border/70 bg-card shadow-sm">
    <CardContent className="space-y-3 p-4">
      <span className={gluceraMicroLabel}>Day Summary</span>
      <div className="grid grid-cols-2 gap-3 pt-1">
        {[
          { label: "Calories", value: nutrition?.["Total Calories"] ?? "—", unit: "kcal" },
          { label: "Carbs", value: nutrition?.["Total Carbohydrates"] ?? "—", unit: "g" },
          { label: "Protein", value: nutrition?.["Total Proteins"] ?? "—", unit: "g" },
          { label: "Fat", value: nutrition?.["Total Fats"] ?? "—", unit: "g" },
        ].map((item) => (
          <div
            key={item.label}
            className="rounded-xl border border-border/60 bg-muted/30 p-3"
          >
            <p className={gluceraStatNano}>{item.label}</p>
            <p className={cn("mt-1", gluceraSummaryValue)}>{item.value}</p>
            <p className={gluceraUnitNano}>{item.unit}</p>
          </div>
        ))}
      </div>
    </CardContent>
  </Card>
);

export default PastDateDaySummaryCard;
